import {useNavigationState} from '@react-navigation/native';

import config from '../config';
import {AppRoute} from '../models/AppRoute';

import type {RouteSpec} from './routes/routes';
import useAppNavigation from './useAppNavigation';

export const isRouteEntryVisibleForLoggedInState =
  (isLoggedIn: boolean) => (route: RouteSpec) => {
    if (route.requiresLogin) {
      return isLoggedIn;
    }
    if (route.requiresLogout) {
      return !isLoggedIn;
    }
    return true;
  };

/**
 * Check if a route exists in the current navigation stack
 * @returns
 */
export function useDoesRouteExist() {
  const routeNames = useNavigationState(state => state.routeNames);
  return (routeName: string) => routeNames.includes(routeName);
}

/**
 * Use this when we want to navigate to a route from checkout flow
 * Check doesRouteExist in current stack first to not break existing functionality.
 */
export function useNavigate() {
  const doesRouteExist = useDoesRouteExist();
  const navigation = useAppNavigation();

  // keep existing functionality until loyalty ff is enabled
  if (!config.FF_LOYALTY_ENABLED) {
    return navigation.navigate;
  }

  return (routeName: string) => {
    if (doesRouteExist(routeName)) {
      navigation.navigate(routeName as any);
    } else {
      navigation.navigate(AppRoute.ROOT_CHECKOUT_FLOW as any, {
        screen: routeName,
      });
    }
  };
}
